import React from 'react';
import { connect } from 'react-redux';
import { Controlled as ReactCodeMirror } from 'react-codemirror2';
import editorSettings from '../../../../const/editorSettings';
import scriptDraftsService from '../../../../services/ScriptDraftService';
import { getScriptTextForScriptArea } from '../../../../services/mini/getScriptTextForScriptArea';
import NoScriptsView from '../NoScriptsView/NoScriptsView';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import getScriptByScriptName from '../../../../services/mini/getScriptByScriptName';
import '../../../../services/cm/comment';
import '../../../../services/cm/alanKeywords';

require('../../../../../../node_modules/codemirror/addon/edit/closebrackets');
require('../../../../services/cm/customSearch');
require('../../../../services/cm/highlightChangedLines');

const options = {
    lineNumbers: false,
    gutters: ['CodeMirror-linenumbers'],
    readOnly: false,
    mode: { name: 'alanKeywords', json: true },
    lint: true,
    matchBrackets: true,
    indentWithTabs: false,
    tabSize: editorSettings.tabSize,
    indentUnit: editorSettings.indentUnit,
};

class ScriptAreaMobile extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            scriptText: null,
        };
    }

    componentDidMount() {
        const { script, environment } = this.props;
        getScriptTextForScriptArea(environment, script).then(scriptText => {
            this.setState({
                scriptText: script ? scriptText : null,
            })
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { script, project, environment } = this.props;
        if (this.state.scriptText === null ||
            (script && prevProps.script && script.scriptId !== prevProps.script.scriptId) ||
            (project?.updateTs !== prevProps.project?.updateTs)) {
            getScriptTextForScriptArea(environment, script).then(scriptText => {
                this.setState({
                    scriptText: script ? scriptText : null,
                })
            });
        }
    }

    updateCode = (text) => {
        const { script, updateScriptTextInEditor } = this.props;
        updateScriptTextInEditor({ script, newScriptText: text });
        this.setState({ scriptText: text });
    }

    render() {
        const {
            environment,
            script,
            hasScripts,
            fontSize,
            codeTheme
        } = this.props;

        const {
            scriptText,
        } = this.state;

        return (
            <div className={`script-area-mobile font-${fontSize} ${codeTheme}`}>
                {
                    (hasScripts) ?
                        <ReactCodeMirror
                            key={script.scriptId}
                            ref="editor"
                            value={scriptText || ""}
                            options={options}
                            onBeforeChange={(editor, data, value) => {
                                this.updateCode(value);
                            }} /> :
                        <NoScriptsView
                            environment={environment}
                        />
                }
            </div>
        );
    }
}


function mapStateToProps({ projectsInfo, scriptEditor }, ownProps) {
    const project = projectsInfo.currentProject;
    const scriptName = ownProps.scriptName;
    const script = getScriptByScriptName(scriptName, project);

    return {
        fontSize: scriptEditor.fontSize,
        codeTheme: scriptEditor.codeTheme,
        script,
        project,
        hasScripts: project.scripts && project.scripts.length,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        updateScriptTextInEditor: (param) => dispatch(scriptEditorActions.updateScriptTextInEditor(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScriptAreaMobile);

